import {RouteObject, Navigate} from 'react-router';

// Opportunities is a SINGLE page with type tabs (university / scholarship /
// course / job / program) driven by `?tab=`. The old per-type listing pages
// (/opportunities/jobs, /scholarships, /universities, /courses) are gone — they
// now redirect to the unified page on the matching tab. Detail pages (:slug)
// are kept, since the unified list links straight to them.
export const opportunitiesRoutes: RouteObject[] = [
  {
    path: 'opportunities',
    lazy: () => import('@app/opportunities/opp-search-page'),
  },

  // The current user's saved opportunities (linked from the avatar menu).
  {
    path: 'favorites',
    lazy: () => import('@app/opportunities/favorites-page'),
  },

  // ── Per-type listings → unified page tabs ───────────────────────────────
  {
    path: 'opportunities/universities',
    element: <Navigate to="/opportunities?tab=university" replace />,
  },
  {
    path: 'opportunities/scholarships',
    element: <Navigate to="/opportunities?tab=scholarship" replace />,
  },
  {
    path: 'opportunities/courses',
    element: <Navigate to="/opportunities?tab=course" replace />,
  },
  {
    path: 'opportunities/jobs',
    element: <Navigate to="/opportunities?tab=job" replace />,
  },

  // ── Detail pages (kept) ─────────────────────────────────────────────────
  {
    path: 'opportunities/universities/:slug',
    lazy: () => import('@app/opportunities/opp-university-detail-page'),
  },
  {
    path: 'opportunities/scholarships/:slug',
    lazy: () => import('@app/opportunities/opp-scholarship-detail-page'),
  },
  {
    path: 'opportunities/courses/:slug',
    lazy: () => import('@app/opportunities/opp-course-detail-page'),
  },
  {
    path: 'opportunities/jobs/:slug',
    lazy: () => import('@app/opportunities/opp-job-detail-page'),
  },
  {
    path: 'opportunities/programs/:slug',
    lazy: () => import('@app/opportunities/opp-program-detail-page'),
  },
];
